export const hasLeadingZeroPhoneDigit = (value: string): boolean => {
  const digitsOnly = String(value || "").replace(/\D/g, "");
  if (!digitsOnly) return false;
  return digitsOnly.startsWith("0");
};
